<template>
  <div class="case_box">
    <el-button type="success" @click="addCase()">新增一个案例</el-button>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="name" label="案例名称" width="200">
      </el-table-column>
      <el-table-column prop="intro" label="安全介绍">
      </el-table-column>
      <el-table-column width="300" label="操作">
        <template slot-scope="scope">
          <el-button type="warning" size="small" @click="Modify(scope.row)">修改</el-button>
          <el-button type="danger" size="small" @click="Del(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {
    instanceList,
    instanceDel
  } from '../api/api'
  import local from '../utils/local'

  export default {
    data() {
      return {
        tableData: [],
        admin_id: local.get('admin_id')
      }
    },
    methods: {
      addCase() {
        this.$router.push('/home/caseDetails')
      },
      Del(id) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          instanceDel(this.admin_id, id).then(res => {
            if (res.data.status == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getInfo()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      getInfo() {
        console.log(this.admin_id)
        instanceList(this.admin_id).then(res => {
          // console.log(res)
          this.tableData = res.data.data;
        })
      },
      Modify(data) {
        this.$router.push({
          path: `/home/caseDetails`,
          query: {
            data: JSON.stringify(data),
          }
        });
      }
    },
    created() {
      this.getInfo()
    }
  }
</script>

<style lang="less" scoped>
  .case_box {
    padding: 0 50px;
    width: 100%;
  }
</style>